import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UrlPrefix } from "../../shared-module/common/constants/url-prefix.constants";

@Injectable()
export class FooterService {
    constructor(private http: HttpClient) { }

    public getFooterData(): Observable<string> {
        return this.http.get<string>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/footer`);
    }

    public getCpqVersion(): Observable<string> {
        return this.http.get<string>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/footer/cpqVersion`);
    }
}
